/**
 * Created by 新思 on 2017/3/3.
 */
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state,
  mutations,
  actions,
  
  getters
}




// WEBPACK FOOTER //
// ./src/vuex/store.js